import { InvoiceCreateButton } from "./invoice.create.button";
import { InvoiceCreateForm } from "./invoice.create.form";

export const InvoiceCreate = {
    Button: InvoiceCreateButton,
    Component: InvoiceCreateForm,
}
